(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9343],{

/***/ 7194:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/teste-de-velocidade",
      function () {
        return __webpack_require__(1656);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ SpeedTest; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_Institutional_InstitutionalPage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3373);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7590);



var __N_SSP = true;
function SpeedTest(param) {
    var data = param.data, navBarData = param.navBarData, ssr = param.ssr, schema = param.schema;
    var _data = data.data, cabecalho = _data.cabecalho, accordion = _data.accordion;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        layoutData: {
            segmentacoes: [],
            tagsData: ssr,
            navBarData: navBarData,
            schema: schema
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Institutional_InstitutionalPage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            text: "",
            title: "Teste de Velocidade",
            headerImg: {
                url: cabecalho.capa.url,
                blurhash: cabecalho.capa.blurhash,
                srcset: cabecalho.capa.srcset
            },
            breadcrumbs: [],
            accordion: accordion,
            type: "velocidade"
        })
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [162,1216,8912,8802,7590,944,6869,3373,9774,2888,179], function() { return __webpack_exec__(7194); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);